import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09f1bbec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "caution-container" }
const _hoisted_2 = { class: "caution" }
const _hoisted_3 = { class: "caution-title" }
const _hoisted_4 = { class: "caution-content" }

import AlertTriangleIcon from "@/assets/svg/register/AlertTriangleIcon.svg?component";

export default /*#__PURE__*/_defineComponent({
  __name: 'CautionContainer',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(AlertTriangleIcon), { class: "alert-icon" }),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "title")
      ]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "content")
      ])
    ])
  ]))
}
}

})